import { get, map } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
};
const initialState = {
  ...resetState,
  isLoading: false,
  requests: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  requestsDetailList: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  appReviewResponse: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET:
      return {
        ...state,
        ...resetState,
      };
    case Constants.APP_LOADING:
      return {
        ...state,
        ...resetState,
        isLoading: action.isLoading,
      };
    case Constants.REQUESTS_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        requestList: action.payload,
      };
    case Constants.REQUESTS_GET_LIST_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        requestsDetailList: action.payload,
      };
    case Constants.REQUEST_GET_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        requestDetails: action.payload,
      };
    case Constants.REQUESTS_GET_LIST_DETAILS_ERROR:
    case Constants.REQUEST_GET_DETAILS_ERROR:
    case Constants.REQUESTS_GET_LIST_ERROR:
      return {
        ...state,
        isListError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.REQUESTS_GET_ORG_SUGGEST_SUCCESS:
      return {
        ...state,
        orgSuggestions: map(action.payload.results, org => ({
          uuid : org.uuid,
          name : org.name,
        })),
      };
    case Constants.REQUESTS_GET_ORG_SUGGEST_ERROR:
      return {
        ...state,
        orgSuggestions: [],
      };
    case Constants.REQUESTS_PUT_SUBMIT_REQUEST:
      return {
        ...state,
        requestUpdateStatus: '',
        operationLoading: true,
      };
    case Constants.REQUESTS_PUT_SUBMIT_SUCCESS:
      return {
        ...state,
        requestUpdateStatus: Constants.SUCCESS,
        operationLoading: false,
      };
    case Constants.REQUESTS_PUT_SUBMIT_ERROR:
      return {
        ...state,
        requestUpdateStatus: Constants.FAIL,
        errors: action.payload,
        operationLoading: false,
      };
    case Constants.REQUESTS_PUT_BULK_SUBMIT_REQUEST:
      return {
        ...state,
        bulkSubmitError: {},
        requestBulkUpdateStatus: '',
        requestBulkUpdateResults : {},
        operationLoading: true,
      };
    case Constants.REQUESTS_PUT_BULK_SUBMIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bulkSubmitError: {},
        requestBulkUpdateStatus: Constants.SUCCESS,
        requestBulkUpdateResults : action.payload,
        operationLoading: false,
      };
    case Constants.REQUESTS_PUT_BULK_SUBMIT_ERROR:
      return {
        ...state,
        isLoading: false,
        requestBulkUpdateStatus: Constants.FAIL,
        requestBulkUpdateResults: [],
        bulkSubmitError: action.payload,
        operationLoading: false,
      };
    case Constants.APPLICATION_REVIEWS_PUT_REQUEST:
      return {
        ...state,
        appReviewUpdateStatus: '',
        operationLoading: true,
      };
    case Constants.APPLICATION_REVIEWS_PUT_SUCCESS:
      return {
        ...state,
        appReviewUpdateStatus: Constants.SUCCESS,
        appReviewResponse: action.payload,
        operationLoading: false,
      };
    case Constants.APPLICATION_REVIEWS_PUT_ERROR:
      return {
        ...state,
        appReviewUpdateStatus: Constants.FAIL,
        appReviewResponse: action.payload,
        operationLoading: false,
      };
    case Constants.REQUEST_WITHDRAW_POST_SUCCESS:
      return {
        ...state,
        appWithdrawStatus: Constants.SUCCESS,
        errors: [],
      };
    case Constants.REQUEST_WITHDRAW_POST_ERROR:
      return {
        ...state,
        appWithdrawStatus: Constants.FAIL,
        errors: action.payload,
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'request.isLoading');

export const getIsError = (state) => get(state, 'request.isError');

export const getErrors = state => get(state, 'request.errors');

export const getListTotalPages = (state) => get(state, 'request.requestList.totalPages');
export const getListTotalElements = (state) => get(state, 'request.requestList.totalElements');
export const getListResults = (state) => get(state, 'request.requestList.results');

export const getDetailsListTotalPages = (state) => get(state, 'request.requestsDetailList.totalPages');
export const getDetailsListTotalElements = (state) => get(state, 'request.requestsDetailList.totalElements');
export const getDetailsListResults = (state) => get(state, 'request.requestsDetailList.results');

export const getRequestDetails = (state) => get(state, 'request.requestDetails');

export const getOrgSuggestions = (state) => get(state, 'request.orgSuggestions',[]);

export const getRequestUpdateStatus = (state) => get(state, 'request.requestUpdateStatus');
export const getAppReviewUpdateStatus = (state) => get(state, 'request.appReviewUpdateStatus');
export const getAppReviewResponse = (state) => get(state, 'request.appReviewResponse');

export const getRequestBulkUpdateStatus = (state) => get(state, 'request.requestBulkUpdateStatus');
export const getRequestBulkUpdateResults = (state) => get(state, 'request.requestBulkUpdateResults');
export const getBulkSubmitError = (state) => get(state, 'request.bulkSubmitError');

export const getAppWithdrawStatus = (state) => get(state, 'request.appWithdrawStatus');
export const getOperationLoading = (state) => get(state, 'request.operationLoading');
